import Progress from './Progress.vue';

export default Progress;



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/components/result/components/progress/index.ts